import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ScanType } from '@services';
import {
    BodyCompositionIcon,
    BodyScanIcon,
    FootScanIcon,
    HandScanIcon,
    HeadScanIcon,
    MotionScanIcon,
    WellnessIcon,
} from '../IconSelectorComponent/IconSelectorComponent';

interface ScanTypeComponentProps {
    scanType: ScanType | undefined;
    fontSize?: string;
    color?: string;
}

const ScanTypeComponent: FC<ScanTypeComponentProps> = (props) => {
    const { scanType, fontSize, color } = props;
    const type = scanType ?? 'BodyScan';
    const {
        t,
    } = useTranslation();

    return (
        <span title={t(type)} data-testid="ScanTypeComponent">
            {type === 'BodyScan' && <BodyScanIcon fontSize={fontSize} color={color} />}
            {type === 'FootScan' && <FootScanIcon fontSize={fontSize} color={color} />}
            {type === 'WellnessScan' && <WellnessIcon fontSize={fontSize} color={color} />}
            {type === 'BodyCompositionScan' && <BodyCompositionIcon fontSize={fontSize} color={color} />}
            {type === 'HandScan' && <HandScanIcon fontSize={fontSize} color={color} />}
            {type === 'HeadScan' && <HeadScanIcon fontSize={fontSize} color={color} />}
            {type === 'MotionScan' && <MotionScanIcon fontSize={fontSize} color={color} />}
        </span>
    );
};

export default ScanTypeComponent;

ScanTypeComponent.defaultProps = {
    fontSize: '1.5rem',
    color: 'primary',
};
